import styled from 'styled-components';
import { Menu } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Dropdown as DefaultDropdown } from 'ui/components/Dropdown';

export const Dropdown = styled(DefaultDropdown)`
  & .anticon {
    transition: transform 0.3s;
    & svg {
      width: 16px;
      height: 16px;
    }
  }

  &.ant-dropdown-open .anticon {
    padding-top: 1px;
    transform: rotate(180deg);
  }
`;

export const MenuWrapper = styled(Menu)`
  &.ant-dropdown-menu {
    padding: 0;
    border-radius: 8px;
    box-shadow:
      0 8px 22px -6px #18274b0a,
      0px 14px 64px -4px #18274b0a;
  }
`;

export const MenuItem = styled(Menu.Item)`
  &.ant-dropdown-menu-item {
    display: flex;
    align-items: center;
    color: ${colors.gray900};
    height: 40px;
    padding-left: 16px;
    padding-right: 16px;
    line-height: 24px;
  }

  &.ant-dropdown-menu-item:hover {
    background-color: #f7f9fe;
  }

  &.ant-dropdown-menu-item > .anticon:first-child {
    margin-right: 10px;

    & svg {
      width: 16px;
      height: 16px;
    }
  }

  &.ant-dropdown-menu-item:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &.ant-dropdown-menu-item:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
